export enum SearchEntityLevels {
  ORGANIZATION = 'ORGANIZATION',
  FEDERATION = 'FEDERATION',
  REGION = 'REGION',
  WORLD = 'WORLD'
}
